module.exports = __webpack_public_path__ + "img/CreditCard.c245b547.png";